/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { getDetailStoryClicks, updateDetailDateRange } from 'state/actions/detailViewState/detailViewStatus';
import { updataDetailDropDown, getStories, fetchCountries, fetchEmbeds, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';
// component
import StoryClicks from 'pages/dashboard/analytics/detail/metrics/storyclicks/storyclicks';



/* ========== ~~~~~~~~~~ DATA STORY CLICKS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ detailViewStatus, sessionStatus, accountData, appStatus }) => ({
    devices: detailViewStatus.devices,
    selectedDevices: detailViewStatus.selectedDevices,
    countries: detailViewStatus.countries,
    selectedCountries: detailViewStatus.selectedCountries,
    sites: accountData.sites,
    selectedSites: detailViewStatus.selectedSites,
    stories: detailViewStatus.stories,
    selectedStories: detailViewStatus.selectedStories,
    embeds: detailViewStatus.embeds,
    selectedEmbeds: detailViewStatus.selectedEmbeds,
    dateRange: detailViewStatus.dateRange,
    storyClicks: detailViewStatus.storyClicks,
    storyClicksFetching: detailViewStatus.storyClicksFetching,

    accountUUID: sessionStatus.accountUUID,
    previousPage: appStatus.previousPage
});

// map actions
const mapDispatchToProps = dispatch => ({
    displayMessage: message => dispatch(displayMessage(message)),
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    updateDetailDropDown: (items, itemType) => dispatch(updataDetailDropDown(items, itemType)),
    fetchCountries: (accountUUID, paramString) => dispatch(fetchCountries(accountUUID, paramString)),
    fetchEmbeds: (accountUUID) => dispatch(fetchEmbeds(accountUUID)),
    getStories: (accountUUID => dispatch(getStories(accountUUID))),
    getDetailStoryClicks: (paramString) => dispatch(getDetailStoryClicks(paramString)),
    clearDetailState: () => dispatch(clearDetailState()),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StoryClicks);
